import { PASSWORD_UPDATE_ERROR, PASSWORD_UPDATE_LOADING, PASSWORD_UPDATE_SUCCESS } from '../Reducers/passwordUpdateReducer';
import { updatePassword as updatePasswordApi } from '../Util/queries';

export const updatePassword = (formData) => async (dispatch) => {
    dispatch({ type: PASSWORD_UPDATE_LOADING });
    try {
        // Build the payload according to API requirements
        const payload = {
            currentPassword: formData.currentPassword,
            newPassword: formData.newPassword
        };
        await updatePasswordApi(payload);
        dispatch({ type: PASSWORD_UPDATE_SUCCESS });
    } catch (error) {
        console.error('Failed to update password:', error);
        dispatch({ type: PASSWORD_UPDATE_ERROR, payload: error.message });
    }
};
